import {
  HEALTH_LIFESTYLE_DATA_REQUEST,
  HEALTH_LIFESTYLE_DATA_SUCCESS,
  HEALTH_LIFESTYLE_DATA_FAIL,
} from '../constants/healthAndLifeStyleConstants';

export const healthLifeStyleReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case HEALTH_LIFESTYLE_DATA_REQUEST:
      return { loading: true, formData: [] };
    case HEALTH_LIFESTYLE_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case HEALTH_LIFESTYLE_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
